/** @format */

import React from "react";
import { Card } from "antd";
import Image from "next/image";
import Link from "next/link";
import { getData } from "../utils/getData";
const { Meta } = Card;

export default function ItemCarousel({ ph }) {
  const adress = `${ph.Strasse}, ${ph.Postleitzahl} ${ph.Ort}`;
  const url = `/pflegeheim/${ph.url}`;

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Link href={url}>
        <Card
          hoverable
          style={{ width: "100%", height: 250, margin: 10 }}
          cover={
            <div
              style={{ position: "relative", width: "100%", height: "110px" }}
            >
              <Image
                objectFit="cover"
                layout="fill"
                alt="example"
                src={
                  ph.images && ph.images.length > 0
                    ? `/api/pflegeheime/${ph._id}/images/${ph.images[0]}`
                    : ph.count
                    ? getData(ph.count, "images")
                    : "/images/nursing-home.jpg"
                }
              />
            </div>
          }
        >
          <Meta title={ph.Name} description={adress} />
        </Card>
      </Link>
    </div>
  );
}
